import { Box } from '@awaze/design-system.components.box';
import { UspList } from '@awaze/design-system.components.usp-list';
import { breakpoints, pxToRems } from '@awaze/design-system.utils.react';
import styled, { css } from 'styled-components';
import Image from 'next/image';
export const UrgencyBadge = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: ${pxToRems(24)};
  border 1px  ${({ theme }) => theme.ColorBlackOpacity100} solid;
  background-color: ${({ theme }) => theme.ColorGrey900};
  color: ${({ theme }) => theme.ColorWhiteOpacity100};
  font-style: inherit;
  line-height: ${({ theme }) => pxToRems(theme.FontTextText100MidLineHeight)};
  font-size: ${({ theme }) => pxToRems(theme.FontTextText100MidFontSize)};
  font-weight: ${({ theme }) => theme.FontTextText100MidFontWeight};
  box-shadow: 0px 0.1px 0.3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px 0px rgba(0, 0, 0, 0.20);
`;
export const StyledTitleAnchor = styled.a `
  color: inherit;
  text-decoration: none;
`;
export const StyledImageContainer = styled.div `
  display: flex;
  height: inherit;
  width: inherit;
`;
export const StyledImage = styled(Image) `
  object-fit: cover;
`;
export const StyledUspList = styled(UspList) `
  padding: ${pxToRems(12)} 0 ${pxToRems(14)} 0;
`;
export const StyledCtaSection = styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
export const StyledDepositButton = styled.button `
  position: relative;
  z-index: 1;
  padding: ${pxToRems(8)} 0;
  background: none;
  border: none;
  font-size: ${({ theme }) => pxToRems(theme.FontTextText100FontSize)};
  font-weight: ${({ theme }) => pxToRems(theme.FontTextText100FontWeight)};
  line-height: ${({ theme }) => pxToRems(theme.FontTextText100LineHeight)};
  text-decoration: underline;
  text-align: right;
  cursor: pointer;
  color: ${({ theme }) => theme.ColorThemeLink};
`;
export const StyledLinkOverlay = styled.a `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
export const StyledPropertyGrid = styled.div `
  height: 100%;

  @media (min-width: ${breakpoints[0]}px) {
    display: grid;
    grid-template-columns: 7fr 5fr;
    grid-template-rows: auto auto;
  }
`;
export const StyledLeftContainer = styled.div `
  height: 100%;
  display: flex;
  flex-direction: row;
  padding: ${pxToRems(16)};

  @media (min-width: ${breakpoints[0]}px) {
    ${({ spanAllRows, isResponsive }) => spanAllRows &&
    isResponsive &&
    css `
        grid-row: ${spanAllRows ? '1 / span 2' : '1'};
      `}

    ${({ isResponsive }) => isResponsive
    ? css `
            padding: ${pxToRems(24)} ${pxToRems(12)};
          `
    : css `
            flex: 1 1 auto;
            justify-content: space-between;
          `}
  }
`;
export const StyledLocationTitle = styled.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-width: calc(100% - 56px);

  @media (min-width: ${breakpoints[0]}px) {
    max-width: 100%;
  }
`;
export const StyledRightContainer = styled.div `
  padding: 0 ${pxToRems(16)} ${pxToRems(16)};

  @media (min-width: ${breakpoints[0]}px) {
    ${({ spanAllRows, isResponsive }) => spanAllRows &&
    isResponsive &&
    css `
        grid-row: ${spanAllRows ? '1 / span 2' : '1'};
      `}
    ${({ isResponsive }) => isResponsive
    ? css `
            padding: ${pxToRems(24)} ${pxToRems(24)} ${pxToRems(24)}
              ${pxToRems(44.8)};
          `
    : css `
            flex: 0 1 fit-content;
          `}
  }

  @media (min-width: ${breakpoints[1]}px) {
    height: 100%;
    ${({ isResponsive }) => isResponsive &&
    css `
        padding-left: ${pxToRems(51.2)} !important;
      `}
  }
`;
export const StyledBannerContainer = styled.div `
  @media (min-width: ${breakpoints[0]}px) {
    grid-column: 1 / span 2;
    grid-row: 2;
  }
`;
export const StyledCarouselContainer = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const StyledRight = styled.div `
  border-top: 1px solid ${({ theme }) => theme.ColorGrey100};
  padding-top: ${pxToRems(16)};
`;
export const StyledReviews = styled.div `
  position: absolute;
  top: ${pxToRems(16)};
  right: ${pxToRems(16)};
`;
export const StyledPropertyTags = styled.div `
  position: absolute;
  top: ${pxToRems(12)};
  right: auto;
  bottom: auto;
  left: ${pxToRems(12)};
  z-index: 999;
  pointer-events: none;
`;
export const ButtonWrap = styled.span `
  display: none;
`;
export const LowDepositContainer = styled.div `
  text-align: center;
`;
export const StyledPropertyCardBox = styled(Box) `
  contain: content;
`;
export const StyledIncludedExtras = styled.div `
  padding-top: ${pxToRems(12)};
`;
export const StyledPropertyCard = styled.article `
  position: relative;
  margin: 0 0 1rem 0;

  ${({ withBackground }) => !withBackground &&
    css `
      @media (max-width: ${breakpoints[0] - 1}px) {
        ${StyledLeftContainer} {
          padding-left: 0;
          padding-right: 0;
        }
      }
    `}

  ${({ isWide, isResponsive }) => isResponsive && isWide
    ? css `
            ${StyledImageContainer} {
              height: 100%;
              min-height: ${pxToRems(255)};
            }

            ${StyledCtaSection} {
              flex-direction: column;
              align-items: flex-end;
            }

            ${StyledDepositButton} {
              z-index: auto;
            }

            ${StyledLinkOverlay} {
              display: none;
            }

            ${StyledLocationTitle} {
              padding-right: 0;
            }

            ${StyledRightContainer} {
              position: relative;
              padding: ${pxToRems(24)};
            }

            ${StyledRight} {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              height: 100%;
              padding-top: 0;
              padding-left: ${pxToRems(24)};
              border-top: 0;
              border-left: 1px solid ${({ theme }) => theme.ColorGrey100};
            }

            ${StyledReviews} {
              position: static;
              top: auto;
              right: auto;
            }

            ${ButtonWrap} {
              display: block;
              width: 100%;
            }
          }
        `
    : css `
          height: 100%;

          ${StyledTitleAnchor} {
            max-height: 32px;
            overflow: hidden;
            display: block;
            text-overflow: ellipsis;
            width: 100%;
            white-space: nowrap;
            word-wrap: break-word;
          }

          > div {
            height: 100%;

            > div {
              height: 100%;
            }
          }
        `}

  ${({ isResponsive }) => !isResponsive &&
    css `
      ${StyledUspList} {
        padding-bottom: 0;
      }
    `}
`;
export const StyledPropertyCardStart = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  aspect-ratio: 4.35 / 3;
  max-width: 100%;
  width: 100%;

  @media (min-width: ${breakpoints[0]}px) {
    max-width: 40%;
  }
`;
export const StyledPropertyCardEnd = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;
//# sourceMappingURL=property-card.styles.js.map